import { Oem } from "./modules/Oem/Page/Oem";
import { OemForm } from "./modules/Oem/Components/OemForm";
import { Account } from "./modules/Account/Page/Account";
import { Device } from "./modules/Device/Page/Device";
import { DeviceLog } from "./modules/DeviceLog/Page/DeviceLog";
import { License } from "./modules/License/Page/License";
import { OemInfo } from "./modules/OemInfo/Page/OemInfo";
import { DeviceForm } from "./modules/Device/Components/DeviceForm";
import { AccountForm } from "./modules/Account/Components/AccountForm";
import { LicenseForm } from "./modules/License/Components/LicenseForm";
import { OemInfoForm } from "./modules/OemInfo/Components/OemInfoForm";
import { Dealer } from "./modules/Dealer/Page/Dealer";
import { DealerForm } from "./modules/Dealer/Components/DealerForm";
import { ProfileForm } from "./global/components/ProfileForm";
import { DeviceLogInfo } from "./modules/DeviceLog/Components/DeviceLogInfo";
import { Customer } from "./modules/Customer/Page/Customer";
import { CustomerForm } from "./modules/Customer/Components/CustomerForm";
import { Sip } from "./modules/Sip/Page/Sip";
import { SipForm } from "./modules/Sip/Components/SipForm";
import { AddSipByListForm } from "./modules/Sip/Components/AddByListForm";
import { AddByCountSipForm } from "./modules/Sip/Components/AddByCountSipForm";
import { Proxy } from "./modules/Proxyserver/Page/Proxy";
import { ProxyForm } from "./modules/Proxyserver/Components/ProxyForm";
import { MySite } from "./modules/MySite/Page/MySite";
import { MySiteForm } from "./modules/MySite/Components/MySiteForm";
import { LicenseCode } from "./modules/LicenseCode/Page/LicenseCode";
import { LicenseCodeForm } from "./modules/LicenseCode/Components/LicenseCodeForm";
import { Invioce } from "./modules/Invoice/Page/Invoice";
import { InvoiceInfoForm } from "./modules/Invoice/Components/InvoiceInfoForm";
import { ProductionForm } from "./modules/Production/Components/ProductionForm";
import { Production } from "./modules/Production/Page/Production";
import { Engage } from "./modules/EngageServer/Page/Engage";
import { EngageForm } from "./modules/EngageServer/Components/EngageForm";
import { Hardware } from "./modules/Hardware/Page/Hardware";
import { HardwareForm } from "./modules/Hardware/Components/HardwareForm";
import { ProductionItemForm } from "./modules/Production/Components/ProductionItemForm";
import InvoiceCreateForm from "./modules/Invoice/Components/InvoiceCreateForm";
import { Order } from "./modules/Order/Page/Order";
import { Purchase } from "./modules/Purchase/Page/Purchase";
import { PurchaseForm } from "./modules/Purchase/Components/PurchaseForm";

export const protectedRoutes = [
  { path: "/profile", element: <ProfileForm /> },
  { path: "/oem", element: <Oem /> },
  { path: "/oem/add", element: <OemForm /> },
  { path: "/oem/edit/:id", element: <OemForm type="edit" /> },
  { path: "/oem/info/:id", element: <OemForm type="info" /> },

  { path: "/site", element: <MySite /> },
  { path: "/site/add", element: <MySiteForm /> },
  { path: "/site/edit/:id", element: <MySiteForm type="edit" /> },
  { path: "/site/info/:id", element: <MySiteForm type="info" /> },
  // { path: "/site/license/:id", element: <SiteLicense type="edit" /> },

  // { path: "/site", element: <Site /> },
  // { path: "/site/add", element: <MySiteForm /> },
  // { path: "/site/edit/:id", element: <MySiteForm type="edit" /> },
  // { path: "/site/info/:id", element: <SiteForm type="info" /> },

  { path: "/device", element: <Device /> },
  { path: "/device/add", element: <DeviceForm /> },
  { path: "/device/edit/:id", element: <DeviceForm type="edit" /> },
  { path: "/device/info/:id", element: <DeviceForm type="info" /> },
  // { path: "/addDeviceByList", element: <AddByListForm /> },
  // { path: "/addDeviceByCount", element: <AddByCountForm /> },

  { path: "/account", element: <Account /> },
  { path: "/account/add", element: <AccountForm /> },
  { path: "/account/edit/:id", element: <AccountForm type="edit" /> },
  { path: "/account/info/:id", element: <AccountForm type="info" /> },

  // { path: "/paymentlist", element: <Payment /> },
  // { path: "/payment/info/:id", element: <PaymentForm /> },

  { path: "/customer", element: <Customer /> },
  { path: "/customer/add", element: <CustomerForm /> },
  { path: "/customer/edit/:id", element: <CustomerForm type="edit" /> },
  { path: "/customer/info/:id", element: <CustomerForm type="info" /> },

  { path: "/devicelog", element: <DeviceLog /> },
  { path: "/devicelog/info/:id", element: <DeviceLogInfo /> },
  // { path: "/orderlist", element: <Order /> },
  // { path: "/order/add", element: <OrderForm /> },
  // { path: "/orderedit/:id", element: <OrderForm /> },
  // { path: "/orderinfo/edit/:id", element: <OrderInfoForm type="edit" /> },
  // { path: "/orderinfo/info/:id", element: <OrderInfoForm type="info" /> },

  // { path: "/orderitemlist", element: <OrderItem /> },
  // { path: "/orderitem/add/:id", element: <OrderItemAddForm /> },
  // { path: "/orderiteminfo/:id", element: <OrderItemForm /> },
  // { path: "/orderitem/info/:id", element: <OrderItemInfoForm type="info" /> },
  // { path: "/orderitem/edit/:id", element: <OrderItemInfoForm type="edit" /> },

  { path: "/license", element: <License /> },
  { path: "/license/add", element: <LicenseForm /> },
  { path: "/license/edit/:id", element: <LicenseForm type="edit" /> },
  { path: "/license/info/:id", element: <LicenseForm type="info" /> },

  { path: "/licensecode", element: <LicenseCode /> },
  { path: "/licensecode/add", element: <LicenseCodeForm /> },
  { path: "/licensecode/edit/:id", element: <LicenseCodeForm type="edit" /> },
  { path: "/licensecode/info/:id", element: <LicenseCodeForm type="info" /> },

  // { path: "/licenseoptionlist", element: <LicenseOption /> },
  // { path: "/licenseoption/add", element: <LicenseOptionForm /> },
  // {
  //   path: "/licenseoption/edit/:id",
  //   element: <LicenseOptionForm type="edit" />,
  // },
  // {
  //   path: "/licenseoption/info/:id",
  //   element: <LicenseOptionForm type="info" />,
  // },
  {
    path: "/order",
    element: <Order />,
  },
  {
    path: "/invoice",
    element: <Invioce />,
  },
  {
    path: "/invoice/info/:id",
    element: <InvoiceInfoForm />,
  },
  {
    path: "/invoice/add",
    element: <InvoiceCreateForm />,
  },

  { path: "/oeminfo", element: <OemInfo /> },
  { path: "/oeminfo/add", element: <OemInfoForm /> },
  { path: "/oeminfo/edit/:id", element: <OemInfoForm type="edit" /> },
  { path: "/oeminfo/info/:id", element: <OemInfoForm type="info" /> },

  { path: "/dealer", element: <Dealer /> },
  { path: "/dealer/add", element: <DealerForm /> },
  { path: "/dealer/edit/:id", element: <DealerForm type="edit" /> },
  { path: "/dealer/info/:id", element: <DealerForm type="info" /> },

  { path: "/sip", element: <Sip /> },
  { path: "/sip/add", element: <SipForm /> },
  { path: "/sip/edit/:id", element: <SipForm type="edit" /> },
  { path: "/sip/info/:id", element: <SipForm type="info" /> },
  { path: "/sip/addSipByList", element: <AddSipByListForm /> },
  { path: "/sip/addSipByCount", element: <AddByCountSipForm /> },
  {
    path: "/proxyserver",
    element: <Proxy />,
  },
  {
    path: "/proxyserver/add",
    element: <ProxyForm />,
  },
  {
    path: "/proxyserver/edit/:id",
    element: <ProxyForm type="edit" />,
  },
  {
    path: "/proxyserver/info/:id",
    element: <ProxyForm type="info" />,
  },

  { path: "/production", element: <Production /> },
  { path: "/production/add", element: <ProductionForm /> },
  { path: "/production/edit/:id", element: <ProductionForm type="edit" /> },
  { path: "/production/info/:id", element: <ProductionForm type="info" /> },
  // { path: "productionitem/add/:id", element: <ProductionItemForm /> },
  {
    path: "productionitem/:id/info/:itemid",
    element: <ProductionItemForm type="info" />,
  },
  // {
  //   path: "addproductionbycount/:id/info/:itemid",
  //   element: <ProductionItemAddbyCount />,
  // },
  // {
  //   path: "addproductionbylist/:id/info/:itemid",
  //   element: <ProductionItemAddbyList />,
  // },
  { path: "/purchase", element: <Purchase /> },
  { path: "/purchase/add", element: <PurchaseForm /> },
  { path: "/purchase/edit/:id", element: <PurchaseForm type="edit" /> },
  { path: "/purchase/info/:id", element: <PurchaseForm type="info" /> },

  { path: "/hardware", element: <Hardware /> },
  { path: "/hardware/add", element: <HardwareForm /> },
  { path: "/hardware/edit/:id", element: <HardwareForm type="edit" /> },
  { path: "/hardware/info/:id", element: <HardwareForm type="info" /> },

  { path: "/engagesitelist", element: <Engage /> },
  // { path: "/engagesite/add", element: <EngageForm /> },
  // { path: "/engagesite/edit/:id", element: <EngageForm type="edit" /> },
  { path: "/engagesite/info/:id", element: <EngageForm type="info" /> },
];
